// extracted by mini-css-extract-plugin
export default {"container":"O8_container__Kw8qW","contentContainer":"O8_contentContainer__XA0OA","title":"O8_title__orLLi"};